import services from './../../services/service'; // Service Class
import Preset from './../../mixins/preset.js'; //preset
import PaymentAndUpdate from './../../mixins/payments_and_updates.js' //payments and updates

let service = new services();

export default {
    name: 'CNInsuranceFileComplaint',
    props: {
        payment_data:Object,
        payment_object:Object
    },
    mixins: [Preset, PaymentAndUpdate],
    data () {
        return {
            active_payment_processing:"false",//checks
            data_processing_message:"",
            active_url: service.siteActiveUrl,
            call_src: 1, //default web app
        }
    },
    components: {
    },
    computed: {
       
    },
    methods: {
        //settings
        resets(){
            this.payment_process_option = 0; //parent call
            this.data_processing_message = "";
        },

        closeModal(modal){
            $(modal).modal("hide");
            $('.modal-backdrop').remove();
            //resets
            this.resets();
        },

        getModalMessage(){
            let msg = localStorage.getItem("payment_modal_message");
            localStorage.removeItem("payment_modal_message");
            return msg;
        },

        resolveIssues(){
            // if(this.$route.params.listing  != ''){
            //     this.$router.push(this.$route.params.listing+'/resolve');
            // }
            let resolve_url = localStorage.getItem("reslove_issues_for");
            if((resolve_url == '') || (resolve_url == undefined)){
                location.replace('/account-cninsurance'); //location.replace('/account-cninsurance/resolve')
            }else{
                this.$router.push(resolve_url+'/resolve');
            }
            //
            $('.modal-backdrop').remove();
        }
    },
    created: function(){
        // setTimeout(function (){
        //     $('#paywith').modal();
        // }, 4000);
        let u_t = localStorage.getItem("cityneeds_token");
        // if((u_t != null)) {
        //     this.preset();
        // }else{
        //     localStorage.setItem("cn_prv_page","businesses");//log current page
        // }
        let self = this;
        setTimeout(function (){
            let cs = localStorage.getItem("cityneeds_call_src");
            if(cs > 0){
                self.call_src = cs;
            }
        }, 500);
    }
}


// WEBPACK FOOTER //
// ./src/templates/CNpaymentModal/script.js